// Date
import {parseISO, isDate, formatISO} from 'date-fns';
import {formatToTimeZone, convertToTimeZone} from 'date-fns-timezone';

// Lib
import getTimeZoneFromBranch from './getTimeZoneFromBranch';

const displayTimeZoneSpecificDate = ({
  date,
  type = null,
  branch = null,
  local = false,
} = {}) => {
  if (!date) return '-';
  try {
    const branchTimeZone = getTimeZoneFromBranch({branch});
    const timeZone =
      branchTimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const parsedDate = isDate(date) ? date : parseISO(date);
    const localizedDate = local
      ? parsedDate
      : convertToTimeZone(date, {timeZone});
    const formattedDate = !!type
      ? type(localizedDate).format()
      : formatISO(localizedDate);
    if (local) return formattedDate;
    const timeZoneAbbreviation = formatToTimeZone(localizedDate, 'z', {
      timeZone,
    });
    return `${formattedDate} ${timeZoneAbbreviation}`;
  } catch (error) {
    return '-';
  }
};

export default displayTimeZoneSpecificDate;
